/**
 * Register Account Form
 */
import trackNewsletter from '../../utils/dynamic-yield/dy-track-newsletter';

export const createCustomer = async (firstName, lastName, email, marketing, tags) => {
  const res = await fetch(
    process.env.CUSTOMER_REGISTRATION_API_ENDPOINT + '/customer',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Shop-Domain': process.env.SHOPIFY_PERMANENT_DOMAIN,
      },
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        marketing,
        tags,
      }),
    }
  );
  return res;
};

export const activateCustomer = async (email, secret) => {
  const res = await fetch(
    process.env.CUSTOMER_REGISTRATION_API_ENDPOINT + `/customer/invite?email=${encodeURIComponent(
      email
    )}&otp=${secret}`,
    {
      method: 'POST',
      headers: {
        'X-Shopify-Shop-Domain': process.env.SHOPIFY_PERMANENT_DOMAIN,
      },
    }
  );
  return res;
};

export const sendOtpEmail = async (email) => {
  const res = await fetch(
    process.env.CUSTOMER_REGISTRATION_API_ENDPOINT + `/customer/update?email=${encodeURIComponent(
      email
    )}`,
    {
      method: 'POST',
      headers: {
        'X-Shopify-Shop-Domain': process.env.SHOPIFY_PERMANENT_DOMAIN,
      },
    }
  );
  return res;
};

const customerTypeObjectMap = {
  M: 'Consumer Male',
  F: 'Consumer Female',
  'Carer M': 'Carer Male',
  'Carer F': 'Carer Female',
};

/**
 * Dynamic Yield - Track the 'Accepts Marketing'
 * Push the DY newsletter event on form submission
 */
function RegisterForm() {
  /**
   * Create a fallback if elements dont exist
   */
  if (!document.getElementById('create_customer')) {
    return false;
  }

  // Execute Functions
  $(document).ready(function () {
    /**
     * Elements prepended with a $ sign are DOM elements
     */
    const selectors = {
      $form: document.getElementById('create_customer'),
      $email: document.getElementById('Email'),
      $acceptsMarketing: document.getElementById('marketing'),
      registrationForm: 'form#create_customer',
      marketingCheckbox: document.querySelector('input[name="customer[accepts_marketing]"]'),
      firstName: document.querySelector('input[name="customer[first_name]"]'),
      registerSection: document.querySelector('.register'),
      otpSection: document.querySelector('.onetime-passcode'),
      lastname: document.querySelector('input[name="customer[last_name]"]'),
      otp1: document.querySelector('input[name="otp-code1"]'),
      otp2: document.querySelector('input[name="otp-code2"]'),
      otp3: document.querySelector('input[name="otp-code3"]'),
      otp4: document.querySelector('input[name="otp-code4"]'),
      otp5: document.querySelector('input[name="otp-code5"]'),
      otp6: document.querySelector('input[name="otp-code6"]'),
      name: document.querySelector('.name'),
      email: document.querySelector('.email'),
      message: document.querySelector('.message'),
      success: document.querySelector('.success'),
      loader: document.querySelector('.loader'),
      noReceive: document.querySelector('.no-receive'),
      noReceiveEmail: document.querySelector('.no-receive span'),
      failure: document.querySelector('.failure'),
      failureEmail: document.querySelector('.failure span'),
      submitBtn: document.querySelector(
        '#create_customer input[type="button"]'
      ),
      tags: document.querySelector('input[name="customer[tags]"'),
      otpInput: document.querySelector('input[name="customer[tags]"'),
      errorContainer: document.querySelector('#create_customer .signup-error'),
      errorMessage: document.querySelector('#create_customer .signup-error li'),
      genderRadioInput:
        '.account-register__customer-type-selector__radio-input',
      carerSection: '.account-register__customer-type-selector__carer',
      carerRadioInput:
        '.account-register__customer-type-selector__carer-radio-input',
    };

    const params = new URLSearchParams(window.location.search);
    if (
      params.has('otp') &&
      params.get('otp') === 'true' &&
      params.has('email') &&
      params.has('name')
    ) {
      const email = params.get('email');
      const name = params.get('name');
      selectors.email.innerHTML = email;
      selectors.$email.value = email;
      selectors.name.innerHTML = name;
      selectors.otpSection.classList.remove('hide');
      selectors.registerSection.classList.add('hide');
    } else {
      selectors.otpSection.classList.add('hide');
      selectors.registerSection.classList.remove('hide');
    }

    const updateShopifyTagsFormInput = (genderInputValue) => {
      const customerType = customerTypeObjectMap[genderInputValue];
      if (customerType) {
        selectors.tags.value = customerType
      } else {
        selectors.tags.value = '';
      }
    };

    selectors.marketingCheckbox.addEventListener('change', (e) => {
      toggleGTMformClass();
    });

    document.querySelectorAll(selectors.genderRadioInput).forEach((item) => {
      item.addEventListener('click', (event) => {
        const selectedGender = event.target.value;
        const carerSection = document.querySelector(selectors.carerSection);

        updateShopifyTagsFormInput(selectedGender);

        if (selectedGender === 'Carer') {
          carerSection.classList.remove('hide');
        } else {
          carerSection.classList.add('hide');
        }
      });
    });

    document.querySelectorAll(selectors.carerRadioInput).forEach((item) => {
      item.addEventListener('click', (event) => {
        const selectedCarerValue = event.target.value;
        updateShopifyTagsFormInput(selectedCarerValue);
      });
    });

    selectors.submitBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (!selectors.$form.checkValidity()) {
        selectors.$form.reportValidity();
        return;
      }
      const email = selectors.$email.value;
      const firstname = selectors.firstName.value;
      const lastname = selectors.lastname.value;
      const marketing = selectors.$acceptsMarketing.checked;
      const tags = selectors.tags.value;
      if (!email || !firstname || !lastname || !tags) {
        return;
      }
      const submitBtn = selectors.submitBtn;
      submitBtn.classList.add('disabled');
      submitBtn.value = 'Creating account...';
      // Hide any previous error messages
      if (selectors.errorContainer) {
        selectors.errorContainer.classList.add('hide');
      }
      try {
        const res = await createCustomer(firstname, lastname, email, marketing, tags);
        if (res.status === 200) {
          selectors.registerSection.classList.add('hide');
          selectors.otpSection.classList.remove('hide');
          // location.href =
          //   '/account/register?otp=true&email=' +
          //   email +
          //   '&name=' +
          //   firstname +
          //   ' ' +
          //   lastname;
        } else {
          // Handle error response
          let errorMsg = 'An error occurred. Please try again.';
          
          try {
            const errorData = await res.json();
            
            // Convert entire response to string to search for duplicate email error
            const responseText = JSON.stringify(errorData).toLowerCase();
            
            if (responseText.includes('already been taken') || responseText.includes('already exists') || responseText.includes('already associated')) {
              errorMsg = 'This email address is already associated with an account. If this account is yours, you can <a style="text-decoration: underline;" href="/account/login#recover">reset your password</a>.';
            } else if (errorData.message) {
              errorMsg = errorData.message;
            }
          } catch (parseError) {
            console.error('Error parsing response:', parseError);
          }
          
          if (selectors.errorMessage && selectors.errorContainer) {
            selectors.errorMessage.innerHTML = errorMsg;
            selectors.errorContainer.classList.remove('hide');
          }
          console.error(res);
        }
      } catch (error) {
        if (selectors.errorMessage && selectors.errorContainer) {
          selectors.errorMessage.innerHTML = 'An error occurred. Please try again yyy.';
          selectors.errorContainer.classList.remove('hide');
        }
        console.error(error);
      } finally {
        const checkbox = selectors.$acceptsMarketing;
        const email = selectors.$email;
        if (checkbox && checkbox.checked && email && email.value) {
          trackNewsletter(email.value);
        }
        submitBtn.classList.remove('disabled');
        submitBtn.value = 'Create account';
      }
    });

    selectors.firstName.addEventListener('change', (e) => {
      selectors.name.innerHTML =
        `${e.target.value} ${selectors.lastname.value}`.trim();
    });

    selectors.lastname.addEventListener('change', (e) => {
      selectors.name.innerHTML =
        `${selectors.firstName.value} ${e.target.value}`.trim();
    });

    selectors.$email.addEventListener('change', (e) => {
      selectors.email.innerHTML = e.target.value;
    });

    const otpEles = [
      selectors.otp1,
      selectors.otp2,
      selectors.otp3,
      selectors.otp4,
      selectors.otp5,
      selectors.otp6,
    ];
    let ctrlOrMeta = false;

    const verifyOTP = async () => {
      selectors.message.classList.add('hide');
      otpEles.forEach((otp) => {
        otp.removeAttribute('disabled', 'disabled');
        otp.classList.remove('error');
      });
      selectors.failure.classList.add('hide');

      const otpValue = otpEles
      .map((o) => o.value)
      .join('')
      .trim();
      // not check until 6 characters
      if (otpValue.length !== 6) {
        return;
      }

      const email = selectors.$email.value;
      if (!email) {
        return;
      }
      try {
        otpEles.forEach((otp) => {
          otp.setAttribute('disabled', 'disabled');
          otp.classList.remove('error');
        });
        selectors.loader.classList.remove('hide');
        selectors.failure.classList.add('hide');
        selectors.noReceive.classList.add('hide');
        const res = await activateCustomer(email, otpValue.toLocaleLowerCase());
        if (res.status === 200) {
          selectors.message.innerHTML = 'Verification Success.';
          selectors.success.classList.remove('hide');
          const body = await res.json();
          setTimeout(() => {
            location.href = body.activationUrl;
          }, 3000);
        } else {
          throw new Error('Verification error');
        }
      } catch (error) {
        console.error(error);
        otpEles.forEach((otp) => {
          otp.classList.add('error');
        });
        selectors.message.innerHTML =
          'Verification error. The code you have entered in not valid.';
          otpEles.forEach((otp) => {
            otp.removeAttribute('disabled');
          });
        selectors.failure.classList.remove('hide');
      } finally {
        selectors.message.classList.remove('hide');
        selectors.loader.classList.add('hide');
      }
    };

    const sendMail = async () => {
      const email = selectors.$email.value;
      if (!email) {
        return;
      }
      try {
        selectors.loader.classList.remove('hide');
        selectors.failure.classList.add('hide');
        selectors.noReceive.classList.add('hide');
        const res = await sendOtpEmail(email);
        if (res.status === 200) {
          selectors.noReceive.classList.remove('hide');
        } else {
          throw new Error('Send email error');
        }
      } catch (error) {
        console.error(error);
      } finally {
        selectors.loader.classList.add('hide');
      }
    };

    otpEles.forEach((otp) => {
      otp.addEventListener('paste', async (e) => {
        e.preventDefault();
        const value = e.clipboardData.getData('text/plain');
        if (value.length > 2) {
          const otpSplit = value.toLocaleUpperCase().split('');
          otpSplit.forEach((value, index) => {
            if (selectors[`otp${index + 1}`]) {
              selectors[`otp${index + 1}`].value = value;
            }
            // move foucs to next input
            if (selectors[`otp${index + 2}`]) {
              selectors[`otp${index + 2}`].focus();
            }
          });
        }
        verifyOTP(); 
      });

      otp.addEventListener('keydown', async (e) => {
        if (e.keyCode === 91 || e.keyCode === 17) {
          ctrlOrMeta = true;
          return;
        }
        if ((e.keyCode < 48 || e.keyCode > 90) || (ctrlOrMeta && e.keyCode === 86)) {
          ctrlOrMeta = false;
          return;
        }
        e.preventDefault();
        // read from clipboard if ctrl+v
        const value = e.key.toLocaleUpperCase();
        if (value.length === 2) {
          // move foucs to next input
          const otpIndex = parseInt(e.target.name.replace('otp-code', ''));
          selectors[`otp${otpIndex}`].value = value[1];
          if (otpIndex < 6) {
            selectors[`otp${otpIndex + 1}`].focus();
          }
        } else {
          // move foucs to next input
          const otpIndex = parseInt(e.target.name.replace('otp-code', ''));
          selectors[`otp${otpIndex}`].value = value;
          if (otpIndex < 6 && value.length !== 0) {
            selectors[`otp${otpIndex + 1}`].focus();
          }
        }
        verifyOTP();
      });
    });

    [selectors.failureEmail, selectors.noReceiveEmail].forEach((ele) => {
      ele.addEventListener('click', async (e) => {
        e.preventDefault();
        selectors.message.classList.remove('hide');
        selectors.message.innerHTML = 'Sending email...';
        await sendMail();
        selectors.message.innerHTML = 'Succcessfully sent email. Please check your inbox.';
      });
    });

    /**
     * Toggle the GTM Newsletter Subscription class
     */
    function toggleGTMformClass() {
      $(selectors.registrationForm).toggleClass('gtm-subscribe-tena-form');
    }
  });
}
export default RegisterForm;
